import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleDebitNote
export const getSaleDebitNote = createAsyncThunk(
  "saleDebitNote/getSaleDebitNote",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getSaleDebitNote({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all saleDebitNote
export const getAllSaleDebitNote = createAsyncThunk(
  "saleDebitNote/getAllSaleDebitNote",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllSaleDebitNote();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("saleDebitNote/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleDebitNote/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleDebitNote/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleDebitNote({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getSaleDebitNoteById = createAsyncThunk(
  "saleDebitNote/getSaleDebitNoteById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleDebitNoteById(id);

      if (data?.data.drCrNotesDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.drCrNotesDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, drCrNotesDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleDebitNote
export const createSaleDebitNote = createAsyncThunk(
  "saleDebitNote/createSaleDebitNote",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderMain,
      drCrNotesDetails,

      drCrNotesPartyDetails,
      // salesOrderMainVehicleDetail,
      // invoiceNo,
      // refNo,
      voucherDateBs,
      voucherDate,
      narration,
      branch,
      termsOfPayment,
      deliveryDocNo,

      salesOrderRequest,
      partyAccount,

      otherReferences,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderMain,
        drCrNotesDetails,
        drCrNotesPartyDetails,
        // salesOrderMainVehicleDetail,
        noteType: "sales_debit",
        // invoiceNo,
        // refNo,
        voucherDateBs,
        voucherDate,
        termsOfPayment,
        branch,
        deliveryDocNo,
        narration,
        salesOrderRequest,
        partyAccount,
        otherReferences,
        termsOfDelivery,
        destination,
        deliveryThrough,
        deliveryDocNumber,
        find,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.createSaleDebitNote(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaleDebitNote = createAsyncThunk(
  "saleDebitNote/updateSaleDebitNote",
  async (params, { rejectWithValue }) => {
    const { id, submitData } = params;
    const {
      salesOrder,
      indentNo,
      voucherDateBs,
      voucherDate,
      branch,
      drCrNotesPartyDetails,

      termsOfPayment,
      // salesOrderMainVehicleDetail,
      // yo field name mileko thiyena, fix bhayo hai
      documentsAttach,
      // refVoucher,
      drCrNotesDetails,

      otherReferences,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      grandTotal,
      vatAmount,
    } = submitData;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        branch,
        status: "approved",
        drCrNotesPartyDetails,
        termsOfPayment,
        // salesOrderMainVehicleDetail,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        drCrNotesDetails,

        otherReferences,
        termsOfDelivery,
        destination,
        deliveryThrough,
        deliveryDocNumber,
        find,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.updateSaleDebitNote(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getSaleDebitNoteDetailsById = createAsyncThunk(
  "saleDebitNote/getSaleDebitNoteDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleDebitNoteDetailsById(id);

      if (data?.data.saleInvoiceDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleInvoiceDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleOrderDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "saleDebitNote/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
